import { render, staticRenderFns } from "./VsDate.vue?vue&type=template&id=06984e9c&lang=pug&"
import script from "./VsDate.vue?vue&type=script&lang=js&"
export * from "./VsDate.vue?vue&type=script&lang=js&"
import style0 from "./VsDate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06984e9c')) {
      api.createRecord('06984e9c', component.options)
    } else {
      api.reload('06984e9c', component.options)
    }
    module.hot.accept("./VsDate.vue?vue&type=template&id=06984e9c&lang=pug&", function () {
      api.rerender('06984e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsDate.vue"
export default component.exports